var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"disabled":_vm.disabled,"type":_vm.type,"size":_vm.size,"plain":_vm.plain,"loading":_vm.loading},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.displayedTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }